<template>
  <v-form>
    <transition name="sidebar-slide">
      <div class="card-side-bar" v-if="isVisible" ref="sidebarRef" @click.stop @pointerdown.stop>
        <div
          v-if="overlayVisible"
          class="transparent-overlay"
          ref="overlayRef"
        ></div>
        <div style="height: 75px">
          <v-row align="center" justify="space-between">
            <span class="task-title">カード詳細</span>
            <v-row
              justify="end"
              align="center"
              class="ml-auto"
              style="margin-right: 10px"
            >
              <!-- ステータス追加ボタン -->
              <v-btn
                @click="openAddStatusDialog"
                icon
                flat
                style="background-color: #f9f9f9"
              >
                <v-tooltip activator="parent" location="top">
                  新しいステータスを追加
                </v-tooltip>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <!-- ステータス追加ダイアログ -->
              <v-dialog v-model="statusDialog" max-width="500px">
                <v-card>
                  <v-card-title class="headline"
                    >新しいステータスを追加</v-card-title
                  >
                  <v-card-text>
                    <v-text-field
                      v-model="newStatusTitle"
                      label="ステータス名"
                      outlined
                      required
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" @click="saveNewStatus(newStatusTitle)">保存</v-btn>
                    <v-btn text @click="closeStatusDialog">キャンセル</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- プロパティ編集ボタン -->
              <v-btn
                @click="openDialog"
                icon
                flat
                style="background-color: #f9f9f9"
              >
                <v-tooltip activator="parent" location="bottom"
                  >プロパティ編集</v-tooltip
                >
                <v-icon>mdi-cog</v-icon>
              </v-btn>

              <!-- エラーダイアログ -->
              <v-dialog v-model="errorDialog" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">エラー</v-card-title>
                  <v-card-text> ステータス名を入力してください。 </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" text @click="errorDialog = false"
                      >閉じる</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- 閉じるボタン -->
              <v-btn
                @mousedown.stop="closeSidebar"
                icon
                flat
                style="background-color: #f9f9f9"
              >
                <v-tooltip activator="parent" location="top">
                  閉じる
                </v-tooltip>
                <v-icon>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-row>
          </v-row>
        </div>
        <div v-if="selectedScreenName === '営業対象者画面'">
          <!-- 社員選択セレクトボックス-->
          <v-autocomplete
            variant="outlined"
            v-model="selectedStaffId"
            :items="allStaff.staffList"
            item-title="staffName"
            item-value="staffId"
            label="社員名を選択"
          />
          <!-- 選択された社員名の表示 -->

          <!--社員情報表示はここ-->
          <div v-if="staffNameVisible">
            <div
              v-for="(value, key) in selectedStaffInfo"
              :key="key"
              class="info-item"
            >
              <v-row>
                <v-col cols="4" align="left" class="font-weight-bold"
                  >{{ key }}:</v-col
                >
                <v-col cols="4" align="left">
                  <div v-if="key === 'パスワード'">
                    <input
                      v-model="selectedStaffInfo['パスワード']"
                      placeholder="入力してください"
                      :style="{ width: '150px', marginLeft: '-8px' }"
                      maxlength="12"
                      outlined
                    />
                  </div>
                  <div v-else>
                    {{ value }}
                  </div>
                </v-col>
                <v-col cols="4" align="left">
                  <div v-if="key === 'パスワード'">
                    <v-btn color="black" @click="createPassword">
                      <v-tooltip activator="parent" location="top"
                        >パスワード新規生成</v-tooltip
                      >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div v-if="selectedScreenName === '営業対象者画面'">
          <v-text-field
            style="margin-top: 10px"
            v-model="copyText"
            readonly
            variant="outlined"
            append-inner-icon="mdi-content-copy"
            @click:append-inner="copyPassword"
          ></v-text-field>
        </div>
        <div v-if="selectedScreenName === '営業対象者画面'">
          <v-btn
            style="margin-bottom: 30px"
            class="skill-sheet"
            @click="skillSheet()"
            >スキルシート作成</v-btn
          >
          <v-btn style="margin-bottom: 30px" color="primary" @click="generatePDF()"
            >PDF出力</v-btn
          >
          <v-btn
            style="margin-bottom: 30px"
            color="primary"
            @click="generateExcel()"
            >Excel出力</v-btn
          >
          <v-file-input
            ref="fileInputRef"
            class="d-none"
            v-model="selectedExcelFile"
            accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @update:modelValue="saveExcelToDatabase"
          />

          <!-- アップロードボタン -->
          <v-btn variant="outlined" color="primary" style="margin-bottom: 30px" @click="triggerFileInput">
            <v-icon start>mdi-cloud-upload</v-icon>
            Excelファイル添付
          </v-btn>
        </div>
        <div v-else class="form-group">
          <!-- <span class="label">タイトル:</span> -->
          <textarea
            ref="autoTextarea"
            v-model="selectedCard.cardTitle"
            class="custom-input"
            rows="1"
            @input="autoResize"
          />
        </div>
        <div
          v-for="(item, index) in properties.filter(
            (p) => p.property?.propertyType !== '8'
          )"
          :key="item.property.propertyId || index"
          class=property-item
        >
          <div
            v-for="(cardValue, cardIndex) in newSelectedCard"
            :key="cardIndex"
          >
            <div
              style="text-align: left"
              v-if="
                cardValue &&
                cardValue.valueId &&
                cardValue.propertyId &&
                item.property &&
                item.property.propertyId &&
                item.property.propertyId === cardValue.propertyId
              "
            >
              <!--ステータス表示はここ-->
              <span class="font-weight-bold">
                {{ item.property.propertyName }}:
                <template v-if="item.property.propertyType == 5">
                    <v-tooltip location="bottom">
                      <template #activator="{ props }">
                        <v-icon
                          v-bind="props"
                          icon="mdi-help-circle-outline"
                          color="primary"
                          class="ml-1"
                          style="cursor: pointer"
                          size="18"
                        />
                      </template>
                      <span>
                      ・Shiftを押しながらEnterキーを押すと改行できます
                      </span>
                    </v-tooltip>
                  </template>
              </span>
              <br /><br />

              <!-- ステータス（propertyName が 'ステータス'）専用の select -->
              <div
                v-if="
                  item.property.propertyName === 'ステータス' &&
                  String(item.property.propertyType) === '7'
                "
              >
                <v-row>
                  <v-col cols="12">
                    <v-select
                      :label="'ステータス選択'"
                      v-model="cardValue.dataValue"
                      variant="outlined"
                      :items="formatSelectionData(cardValue.selectionData)"
                      item-title="selectionData"
                      item-value="selectionId"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          @mousedown.stop="openAddStatusDialog"
                          class="action-icon"
                          @click.stop
                        >
                          mdi-text-box-plus-outline
                        </v-icon>
                        <v-tooltip text="ステータス削除" location="bottom">
                          <template #activator="{ props }">
                            <v-icon
                              v-bind="props"
                              @mousedown.stop="getSelectedIndex(cardValue)"
                              class="action-icon"
                              @click.stop
                            >
                              mdi-trash-can
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </div>

              <!-- ステータス以外の propertyType === '7' -->
              <div v-else-if="String(item.property.propertyType) === '7'"
              :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]">
                <v-row>
                  <v-col cols="12">
                    <v-select
                      :label="'セレクト'"
                      v-model="cardValue.dataValue"
                      variant="outlined"
                      :items="formatSelectionData(cardValue.selectionData)"
                      item-title="selectionData"
                      item-value="selectionId"
                      @focus="handleFocus(cardValue.propertyId)"
                      @blur="handleBlur" 
                      @keydown.enter.prevent="focusOut"
                      @keydown.esc="focusOut"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          @mousedown.stop="
                            openNewValueDialog(
                              cardValue.valueId,
                              cardId,
                              cardValue.propertyId,
                              formatSelectionData(cardValue.selectionData)
                            )
                          "
                          class="action-icon"
                          @click.stop
                        >
                          mdi-text-box-plus-outline
                        </v-icon>
                        <v-icon
                          @mousedown.stop="
                            deleteValue(cardValue.valueId, cardValue.dataValue, cardValue.selectionData)
                          "
                          class="action-icon"
                          @click.stop
                        >
                          mdi-trash-can
                        </v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </div>

              <div
              @mousedown.stop
                v-else-if="!item.selectionItem && String(item.property.propertyType) === '1'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-text-field
                  :label="'数量'"
                  v-model="cardValue.dataValue"
                  type="number"
                  variant="outlined"
                  color="primary"
                  @focus="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur" 
                  @keydown.enter.prevent="focusOut"
                  @keydown.esc="focusOut"
                  @input="(event) => handleQuantityInput(event, cardValue)"
                />
              </div>
              <div
                v-else-if="
                  !item.selectionItem &&
                  String(item.property.propertyType) === '2'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-text-field
                  :label="'少数'"
                  v-model="cardValue.dataValue"
                  type="number"
                  color="primary"
                  variant="outlined"
                  @focus="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur" 
                  @keydown.enter.prevent="focusOut"
                  @keydown.esc="focusOut"
                  @input="(event) => handleDecimalInput(event, cardValue)"
                />
              </div>
              <div
                v-else-if="
                  !item.selectionItem &&
                  String(item.property.propertyType) == '3'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-text-field
                  :label="'日付'"
                  v-model="cardValue.dataValue"
                  max="2500-12-31"
                  type="date"
                  variant="outlined"
                  color="primary"
                  @click="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur" 
                  @keydown.enter.prevent="focusOut"
                  @keydown.esc="focusOut"
                />
              </div>
              <div
                v-else-if="
                  !item.selectionItem &&
                  String(item.property.propertyType) == '4'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-text-field
                  :label="'時間'"
                  v-model="cardValue.dataValue"
                  color="primary"
                  variant="outlined"
                  type="time"
                  @focus="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur" 
                  @keydown.enter.prevent="focusOut"
                  @keydown.esc="focusOut"
                />
              </div>
              <div
                v-else-if="
                  !item.selectionItem &&
                  String(item.property.propertyType) === '5'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-textarea
                  :label="'テキスト'"
                  v-model="cardValue.dataValue"
                  type="string"
                  color="primary"
                  variant="outlined"
                  @keydown.enter.prevent="handleTextEnter($event)"
                  @focus="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur"
                  @keydown.esc="focusOut"
                />
              </div>
              <div
                v-else-if="
                  !item.selectionItem &&
                  String(item.property.propertyType) == '6'
                "
                :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
              >
                <v-list class="custom-list">
                  <v-list-item class="custom-list-item">
                    <v-list-item-title>
                      <div class="d-flex align-center gap-2">
                        <!-- ファイルアップロード -->
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <div style="width: 12%" v-bind="props">
                              <v-file-input
                                class="custom-file-input"
                                hide-input
                                :label="'ファイル'"
                                variant="outlined"
                                color="primary"
                                prepend-icon="mdi-paperclip"
                                counter
                                show-size
                                v-model="cardValue.dataValue"
                                @focus="handleFocus(cardValue.propertyId)"
                                @blur="handleBlur" 
                                @keydown.enter.prevent="focusOut"
                                @keydown.esc="focusOut"
                              />
                            </div>
                          </template>
                          <span>ファイルを添付</span>
                        </v-tooltip>

                        <!-- ファイル名「リンク」＆ファイル削除ボタン「✖」 -->
                        <div
                          class="d-flex align-center file-link-container"
                          style="width: 100%"
                        >
                          <v-tooltip location="top">
                            <template #activator="{ props }">
                              <a
                                v-bind="props"
                                :href="fileItems[cardValue.valueId]?.blobUrl"
                                :download="
                                  fileItems[cardValue.valueId]?.fileName
                                "
                                class="file-link"
                              >
                                {{
                                  getShortFileName(
                                    fileItems[cardValue.valueId]?.fileName
                                  )
                                }}
                              </a>
                            </template>
                            <span>{{
                              fileItems[cardValue.valueId]?.fileName
                            }}</span>
                          </v-tooltip>

                          <span
                            class="ml-2"
                            v-if="fileItems[cardValue.valueId]?.fileSize"
                          >
                            {{ fileItems[cardValue.valueId].fileSize }}
                          </span>

                          <v-icon
                            color="red"
                            class="ml-1 no-shrink"
                            @click="
                              deleteFile(
                                cardValue.valueId,
                                fileItems[cardValue.valueId]?.fileName
                              )
                            "
                            v-if="fileItems[cardValue.valueId]?.fileName"
                          >
                            mdi-close
                          </v-icon>
                        </div>
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>
              <div class="property-actions"></div>
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in properties.filter(
            (p) => p.property?.propertyType == '8'
          )"
          :key="item.property.propertyId || index"
          class=property-item
        >
          <div
            v-for="(cardValue, cardIndex) in newSelectedCard"
            :key="cardIndex"
          >
            <div
              style="text-align: left"
              v-if="
                cardValue &&
                cardValue.valueId &&
                cardValue.propertyId &&
                item.property &&
                item.property.propertyId &&
                item.property.propertyId === cardValue.propertyId
              "
            >
              <span
                v-if="item.property.propertyName != 'ステータス'"
                class="font-weight-bold"
              >
                {{ "コメント" }}:
                <v-tooltip location="bottom">
                  <template #activator="{ props }">
                    <v-icon
                      v-bind="props"
                      icon="mdi-help-circle-outline"
                      color="primary"
                      class="ml-1"
                      style="cursor: pointer"
                      size="18"
                    />
                  </template>
                  <span
                    >・Shiftを押しながらEnterキーを押すと改行できます<br />
                    ・「変更を保存」を押せず、「↑」やエンターキーだけで保存が出来ます</span
                  >
                </v-tooltip>
              </span>
              <br /><br />
              <div>
                 <v-textarea
                  :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
                  :label="'コメント'"
                  color="primary"
                  v-model="userInputText[item.property.propertyId]"
                  variant="outlined"
                  counter="5000"
                  maxlength="5000"
                  auto-grow
                  rows="1"
                  @keydown.enter.prevent="handleEnterKey($event, item)"
                  @keydown.tab.prevent="
                    addUserInputText(
                      this.cardId,
                      item.property.propertyId,
                      item.property.propertyType
                    )"
                  @focus="handleFocus(cardValue.propertyId)"
                  @blur="handleBlur"
                  @keydown.esc="focusOut"
                                  >
                  <template v-slot:append-inner>
                    <v-icon
                      @click.stop="
                        addUserInputText(
                          cardId,
                          item.property.propertyId,
                          item.property.propertyType
                        )
                      "
                      :class="{
                        'disabled-icon':
                          !userInputText[item.property.propertyId] ||
                          String(userInputText[item.property.propertyId])
                            .length > 5000,
                        'active-icon':
                          userInputText[item.property.propertyId] &&
                          String(userInputText[item.property.propertyId])
                            .length <= 5000,
                      }"
                    >
                      mdi-arrow-up-circle
                    </v-icon>
                  </template>
                </v-textarea>
                <div class="user-input-box-container">
                  <div
                    v-for="(text, index) in userInputTextBox
                      .filter((t) => t.propertyId === item.property.propertyId)
                      .sort(
                        (a, b) =>
                          new Date(a.createdDate) - new Date(b.createdDate)
                      )"
                    :key="index"
                    class="user-input-box"
                  >
                    <v-avatar
                      style="margin-bottom: 28px; margin-left: 5px"
                      color="blue"
                      class="dynamic-avatar"
                      :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
                    >
                      <span class="avatar-text">{{
                        text.createdUser?.charAt(0) || "？"
                      }}</span>
                    </v-avatar>
                    <v-textarea
                      v-model="text.dataValue"
                      :class="['property-item', { focused: focusedPropertyId === cardValue.propertyId }]"
                      style="margin-left: 10px"
                      variant="outlined"
                      density="compact"
                      :readonly="userFullName != text.createdUser"
                      :hint="`${text.createdUser || '不明'} | ${
                        text.createdDate ? text.createdDate : '日付不明'
                      } ${
                        text.createdDate != text.updatedDate ? '(' + text.updatedDate + ')' : ''
                      }`"
                      persistent-hint
                      maxlength="5000"
                      auto-grow
                      :loading="text.loading"
                      rows="1"
                      @keydown.enter.prevent="
                        handleUpdateEnterKey($event, index, text)
                      "
                      @focus="handleFocus(cardValue.propertyId)"
                      @blur="handleBlur"
                      @keydown.esc="focusOut"
                    ></v-textarea>

                    <!-- ❌削除ボタン  -->
                    <button
                      v-if="userFullName === text.createdUser"
                      style="margin-bottom: 24px"
                      @click.stop.prevent="removeUserInputText(text)"
                    >
                      ❌
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" @click="saveChanges" class="save-button">
          変更を保存
        </button>
      </div>
    </transition>

    <!-- ステータス追加ダイアログ -->
    <v-dialog v-model="addValueDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">新しい値 追加</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newValueTitle"
            label="名前入力"
            outlined
            required
            :counter="20"
            :rules="nameRules"
            color="primary"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="addValueDialog = false; newValueTitle = null;">キャンセル</v-btn>
          <v-btn
            :disabled="!newValueTitle || newValueTitle.length > 20"
            color="primary"
            @click="saveNewValue()"
            >保存</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- プロパティ編集ダイアログ (条件付き表示) -->
     <property-edit
      v-if="propertyDialog"
      @update:dialogVisible="updateDialogVisible"
      :dialogVisible="propertyDialog"
      :data="cardData"
      :tableId="tableId"
      :selectedCardId="cardId"
      @refreshProperties="getBoardViewInfo"
      @refreshCardSidebar="fetchCardData"
    />

    <card-edit @refreshProperties="getBoardViewInfo" />
  </v-form>
</template>

<script>
import staffApi from "@/api/getStaffInfo";
import PropertyEdit from "./PropertyEdit.vue";
import cardApi from "@/api/card";
import skillSheetApi from "@/api/skillSheet";
import pdf from "@/api/pdf";
import excel from "@/api/excel";
import savePasswordApi from "@/api/cardSidebar";
import cardSidebarApi from "@/api/cardSidebar";
import taskCardApi from "@/api/card";
import boardViewApi from "@/api/boardView.js";
import eventBus from "@/eventBus";

export default {
  emits: ["update:isVisible", "update-task", "save-new-card", "triggerSearch"],
  components: {
    PropertyEdit,
  },
  props: {
    isVisible: Boolean,
    getProperties: Object,
    selectedSideCard: Object,
    cardStaffId: Number,
  },

  data() {
    return {
      userFullName: "", // ユーザーの氏名
      selectedExcelFile: null,
      errorDialog: false,
      propertyDialog: false, // ダイアログの表示状態
      cardData: [],
      newStatusName: "",
      statusDialog: false, // ダイアログの表示/非表示
      newStatusTitle: "", // 新しいステータス名
      statusList: [], // ステータスリスト
      copyText: "社員にスキルシートアドレスを送る",
      updatedDate: null,
      nameRules: [
        (v) => !!v || "名前を入力してください。",
        (v) =>
          (v && v.length <= 20) || "名前は20文字以下まで入力してください。",
      ],
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      staffNameVisible: false,
      fileItems: {},
      fileData: {},
      fileTrashCan: {},
      selectedValue: "",
      addValueDialog: false,
      newValueTitle: "",
      tableId: null,
      properties: {},
      propertyId: null,
      cardId: null,
      valueId: null,
      newSelectedCard: {},
      newPropertyName: "",
      allStaff: [],
      selectedScreenName: null,
      selectedStaffId: null, // 選択された社員ID
      selectedStaffName: null, //選択された社員名
      selectedStaffNum: null, //選択された社員の番号
      selectedStaffInfo: {}, // 選択された社員の詳細情報
      staffIdFromInfo: null,
      staffNum: "",
      staffName2: "",
      onlyStaffName: "",
      userInputText: {},
      userInputTextBox: [],
      originalUserInputTextBox: [],
      userInputTextTrashCan: [],
      overlayVisible: false,
    };
  },
  watch: {
    searchResult: {
      handler() {
        this.loadTaskCards();
      },
    },
    isVisible(newVal) {
      if (newVal) {
        setTimeout(() => {
          document.addEventListener("click", this.handleClickOutside);
        }, 0);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    newSelectedCard: {
      async handler(newVal, oldVal) {
        for (let i = 0; i < newVal.length; i++) {
          const newItem = newVal[i];
          const oldItem = oldVal?.[i];
          const valueId = newItem.valueId;

          // 🔍 propertyType 6のみ
          if (newItem.propertyType !== "6") continue;
          if (!valueId) continue;

          const dataValue = newItem.dataValue;

          // Fileが オブジェクトの場合
          if (dataValue instanceof File) {
            const size = dataValue.size;
            const units = ["Bytes", "KB", "MB", "GB", "TB"];
            const exponent = Math.floor(Math.log10(size || 1) / 3);
            const value = (size / Math.pow(1000, exponent)).toFixed(1);
            const fileSize = `${value} ${units[exponent]}`;

            this.fileItems[valueId] = {
              blobUrl: URL.createObjectURL(dataValue),
              fileName: dataValue.name,
              fileSize,
            };
          }

          // 値が文字列で以前の値と異なる場合のみ
          else if (
            typeof dataValue === "string" &&
            (!oldItem || oldItem.dataValue !== dataValue)
          ) {
            await this.downloadFile(valueId, dataValue);
          }

          // 値がなければ初期化
          else if (!dataValue) {
            this.fileItems[valueId] = {
              blobUrl: "",
              fileName: "",
              fileSize: "",
            };
          }
        }
      },
      deep: true,
    },
    selectedStaffId(newId) {
      if (this.selectedScreenName === "営業対象者画面") {
        if (newId) {
          this.getStaffInfo(newId, this.cardId);
        }
        this.staffNameVisible = true;
        this.updateCardTitle(newId);
      } else {
        this.staffNameVisible = false;
      }
    },
    getProperties: {
      handler(newProperties) {
        this.properties = newProperties;
      },
      immediate: true,
    },
    selectedSideCard: {
      handler(newCard) {
        this.updateSelectedCard(newCard);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
  eventBus.on("card-status-updated", (updatedCardId) => {
    if (updatedCardId) {
      if (updatedCardId == this.cardId) {
        this.fetchCardData(updatedCardId);
      }
    } else {
      console.warn("cardIdが渡されていません");
    }
    });
  },
  mounted() {
    this.userFullName = localStorage.getItem("fullName");
    this.getBoardViewInfo();
    this.getAllStaffName();
    const screenData = JSON.parse(sessionStorage.getItem("screenData"));
    this.selectedScreenName = screenData.screenName;
    this.selectedExcelFile = [];
    // this.selectedScreenName = sessionStorage.getItem("screenName");
    },
  methods: {
    closeStatusDialog() {
      this.statusDialog = false;
      this.newStatusTitle = '';
    },
    getSelectedIndex() {
      const statusData = this.newSelectedCard.find(
        (c) => c.propertyName === 'ステータス' && String(c.propertyType) === '7'
      );
      const itemCount = statusData.selectionData?.length || 0;
      if (itemCount <= 1) {
        alert("ステータスが1個以下の時は削除できません。\n最低1つのステータスは保持する必要があります。");
        return;
      }
      if (!confirm("本当に削除しますか？この操作は元に戻せません。")) {
        return;
      }

      const deleteData = {
        cards: statusData ? [statusData] : [],
        propertyId: statusData?.propertyId,
        propertyName: statusData?.propertyName,
        dataValue: statusData?.dataValue,
      };
      this.deleteData(deleteData);
    },
    async deleteData(statusData) {
      if (!statusData || !Array.isArray(statusData.cards)) {
        alert("削除するデータが存在しません。");
        return;
      }

      const { propertyId, propertyName, dataValue } = statusData;
    
      this.authUserId = localStorage.getItem("authUserId");
      this.sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");
    
      try {
        const response = await cardApi.deleteData(
          [],
          propertyId,
          propertyName,
          dataValue,
          this.authUserId,
          this.sessionKey,
          staffName
        );
    
        if (response.status === 200) {
          alert("プロパティの削除が正常に更新されました。");
          window.location.reload();
        } else {
          alert("プロパティ名の更新に失敗しました。");
        }
      } catch (err) {
        console.error("データ削除中にエラーが発生しました。", err);
      }
    },
    autoResize() {
      const el = this.$refs.autoTextarea;
      if (!el) return;

      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
    },
    encode(str) {
      if (str == null) {
        return;}
      const utf8Bytes = new TextEncoder().encode(str);
      const binaryString = Array.from(utf8Bytes)
        .map(byte => String.fromCharCode(byte))
        .join('');
      return btoa(binaryString);
    },
    getShortFileName(fullName) {
      if (!fullName) return "";
    
      const maxLength = 47;
      const dotIndex = fullName.lastIndexOf(".");
      if (dotIndex === -1) return fullName;
    
      const name = fullName.slice(0, dotIndex);
      const extension = fullName.slice(dotIndex);
    
      if (fullName.length <= maxLength) {
        return fullName;
      }
    
      const chars = Array.from(name);
      const shortLength = maxLength - extension.length - 3;
      const shortName = chars.slice(0, shortLength).join("");
    
      return `${shortName}...${extension}`;
    },
    handleTextEnter(event) {
      if (event.shiftKey) {
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const value = textarea.value;
        textarea.value =
          value.substring(0, start) + "\n" + value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 1;
      } else {
        this.focusOut(event);
      }
    },
    handleEnterKey(event, item) {
      if (event.shiftKey) {
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const value = textarea.value;
        textarea.value =
          value.substring(0, start) + "\n" + value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 1;
      } else {
        this.addUserInputText(
          this.cardId,
          item.property.propertyId,
          item.property.propertyType
        );
      }
    },
    handleUpdateEnterKey(event, index, text) {
      if (event.shiftKey) {
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const value = textarea.value;
        textarea.value =
          value.substring(0, start) + "\n" + value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 1;
      } else {
        if (!text.dataValue) {
          alert("コメントを入力してください。");
          return;}
        this.updateUserInputText(index, text.dataValue, text.createdUser);
      }
    },
    triggerFileInput() {
      const inputEl = this.$refs.fileInputRef?.$el?.querySelector("input");
      if (inputEl) {
        inputEl.click();
      }
    },
    async saveExcelToDatabase(file) {
      const staffId = this.selectedStaffId;
      if (!staffId) {
        alert("社員名を選択してください");
        this.selectedExcelFile = [];
        return;
      }

      if (!file) {
        this.selectedExcelFile = [];
        return;
      }

      const userName = localStorage.getItem("staffName");
      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");
      await skillSheetApi.deleteAllSkillSheets(authUserId, sessionKey, staffId);
      
      const result = excel.createSkillSheet(file, staffId, userName);

      console.log("parsing data: ", result);
    },

    updateDialogVisible(newVal) {
      this.propertyDialog = newVal;
    },

    // ダイアログを開く
    async openDialog() {
      await this.getBoardViewInfo();
      this.propertyDialog = true;
    },
    async generateExcel() {
      try {
        const staffId = this.selectedStaffId;
        if (staffId) {
          this.authUserId = localStorage.getItem("authUserId");
          this.sessionKey = localStorage.getItem("sessionKey");
          const result = await skillSheetApi.getSkillSheet(
            this.authUserId,
            this.sessionKey,
            staffId
          );
          const excelFile = excel.createExcelFile(result, this.onlyStaffName);
          return excelFile;
        } else {
          console.log("社員IDが存在しません", staffId);
        }
      } catch (error) {
        if (error.status === 400) {
          alert(error.message);
        } else {
          alert(`Excel作成中にエラーが発生しました。`);
        }
        console.log("Excel作成中にエラー発生：", error);
      }
    },
    async getBoardViewInfo() {
      this.loading = true;
      this.tableId = sessionStorage.getItem("tableId");
      if (
        this.tableId != "undefined" &&
        this.tableId != null &&
        this.tableId != undefined
      ) {
        const authInfo = {
          authUserId: this.authUserId,
          sessionKey: this.sessionKey,
        };

        this.cardData = await boardViewApi.getBoardViewInfo(
          this.tableId,
          authInfo
        );
        console.log("this.cardData", this.cardData);
        if (this.cardData && Array.isArray(this.cardData.data)) {
          // 検索結果を取得できた場合は格納
          this.properties = this.cardData.data[0].properties;
          this.ErrMsg = null;
          console.log("this.properties : ", this.properties);
          // this.boardTitle = this.cardData.data[0].tableInfoDto.tableName;
        } else {
          // データが取得できなかった場合の処理
          this.properties = null;
          this.ErrMsg = "データが存在しません";
          console.log("データが存在しません");
        }
      } else {
        console.log("tableIdがNULL又はUndefinedです tableId: ", this.tableId);
      }
      this.loading = false;
    },
    openAddStatusDialog() {
      this.statusDialog = true;
    },
    async saveNewStatus(newStatusTitle) {
      const tableId = sessionStorage.getItem("tableId");

      if (!newStatusTitle) {
        this.errorDialog = true;
        return;
      }
      
      const invalidCharRegex = /\\\\|[,:]/;
      if (invalidCharRegex.test(newStatusTitle)) {
          alert("ステータス名に「\\\\」「,」「:」は使用できません。");
          return;
        }
      
      const statusData = this.newSelectedCard.find(
        (c) => c.propertyName === 'ステータス' && String(c.propertyType) === '7'
      );
        
        let statusNameList = [];
        if (statusData?.selectionData && Array.isArray(statusData.selectionData)) {
          statusNameList = statusData.selectionData
            .map(item => item.split(':')[1]?.trim())
            .filter(name => !!name);
        }

        if (statusNameList.includes(newStatusTitle)) {
          alert("既に存在するステータス名です。");
          return;
        }  

      if (newStatusTitle.trim()) {
        const staffName = localStorage.getItem("staffName");
        this.newStatusTitle = newStatusTitle.trim();
        this.statusDialog = false;
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        await cardSidebarApi.addStatus(
          tableId,
          this.newStatusTitle,
          staffName,
          authUserId,
          sessionKey
        );
        await this.fetchCardData(this.cardId);
        this.$emit("triggerSearch");
        eventBus.emit("refreshBoardView");
        this.loadTaskCards();
        this.newStatusTitle = null;
      } else {
        this.errorDialog = true;
        return;
      }
    },
    async addNewCard(propertyId, statusKey, cardTitle) {
      try {
        const staffName = localStorage.getItem("staffName");
        console.log(
          "カード追加propertyId:",
          propertyId,
          "statusKey:",
          statusKey,
          "cardTitle:",
          cardTitle
        );
        await taskCardApi.addNewCard(
          this.authUserId,
          this.sessionKey,
          this.tableId,
          propertyId,
          statusKey,
          cardTitle,
          staffName
        );
        await this.$emit("triggerSearch");

        this.loadTaskCards();

        console.log("addNewCard - 成功");
      } catch (error) {
        console.error("addNewCard - 失敗:", error.message);
      }
    },
    async loadTaskCards() {
      try {
        this.uniqueStatus = await this.searchResult;
      } catch (error) {
        this.errorMessage =
          error.message || "タスクカードの読み込みに失敗しました";
        console.log(error.message);
      }
    },
    updateCardInfo(updatedTask) {
      console.log("updateCardInfo:", updatedTask);
      const cardIndex = this.cards.findIndex(
        (card) => card === this.selectedCard
      );
      if (cardIndex !== -1) {
        this.cards[cardIndex] = { ...this.selectedCard, ...updatedTask };
        console.log("updateCardInfo:", this.cards[cardIndex]);
      } else {
        console.log("updateCardInfo - Card not found");
      }
      this.$emit("triggerSearch");
      this.loadTaskCards();
      this.closeSidebar();
    },

    async addUserInputText(cardId, propertyId, propertyType) {
      const createdUser = localStorage.getItem("fullName");
      this.authUserId = localStorage.getItem("authUserId");
      this.sessionKey = localStorage.getItem("sessionKey");
      const inputText = this.userInputText[propertyId];
      if (inputText) {
        const now = new Date();
        const tokyoTime = now.toLocaleString("ja-JP", {
          timeZone: "Asia/Tokyo",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        });

        this.userInputTextBox.push({
          valueId: null,
          cardId,
          propertyId,
          propertyType,
          dataValue: inputText,
          createdDate: tokyoTime,
          updatedDate: tokyoTime,
          createdUser: createdUser,
          loading: false,
        });
        await this.updateComment(this.authUserId, this.sessionKey, {});

        this.userInputText[propertyId] = "";
      }
    },
    updateUserInputText(index, newValue, createdUser) {
      try {
        if (this.userFullName === createdUser) {
          this.userInputTextBox[index].loading = true;
          if (newValue && newValue.length <= 90) {
            // ✅ 日本時間 (UTC+9) の現在時刻を取得
            const now = new Date();
            const tokyoTime = now.toLocaleString("ja-JP", {
              timeZone: "Asia/Tokyo",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false, // 24時間形式
            });
            const updatedUser = localStorage.getItem("staffName");

            this.userInputTextBox[index].dataValue = newValue;
            this.userInputTextBox[index].updatedDate = tokyoTime; // ✅ 変更されたデータのみ更新
            this.userInputTextBox[index].updatedUser = updatedUser;
          }
          this.updateComment(this.authUserId, this.sessionKey, {});

          setTimeout(() => {
            this.userInputTextBox[index].loading = false;
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    removeUserInputText(targetText) {
      const staffName = localStorage.getItem("staffName");
      if (!confirm("本当に削除しますか？この操作は元に戻せません。")) {
        return;
      }

      const index = this.userInputTextBox.findIndex(
        (entry) => entry === targetText
      );

      if (index !== -1) {
        const removedEntry = this.userInputTextBox.splice(index, 1)[0];
        if (removedEntry.valueId != null) {
          this.userInputTextTrashCan.push(removedEntry);
        } else {
          console.log(
            "追加されたばかりのアイテムのため、ゴミ箱に追加されません。"
          );
        }

        if (this.userInputTextTrashCan.length > 0) {
          cardSidebarApi.deleteUserInputText(
            this.userInputTextTrashCan,
            staffName
          );
        }
      }
    },
    async generatePDF() {
      try {
        const staffId = this.selectedStaffId;
        if (staffId) {
          this.authUserId = localStorage.getItem("authUserId");
          this.sessionKey = localStorage.getItem("sessionKey");
          const result = await skillSheetApi.getSkillSheet(
            this.authUserId,
            this.sessionKey,
            staffId
          );
          const pdfFile = pdf.outputPDF(1, "file", result, this.onlyStaffName);
          return pdfFile;
        } else {
          console.log("社員IDが存在しません", staffId);
        }
      } catch (error) {
          if (error.status === 400) {
            alert(error.message);
          } else {
            alert(`PDF作成中にエラーが発生しました。`);
          }
          console.log("PDF作成中にエラー発生：", error);
        }
    },
    async downloadFile() {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        let fileName = "";
        let valueId = null;
        for (const item of this.newSelectedCard) {
          if (item.propertyType === "6" && item.dataValue) {
            fileName = item.dataValue;
            valueId = item.valueId;
            if (valueId && Object.keys(fileName).length > 0) {
              const response = await cardSidebarApi.downloadFile(
                valueId,
                fileName,
                authUserId,
                sessionKey
              );

              if (response) {
                const blob = response.data;

                const contentDisposition = response.headers["content-disposition"];
                let resolvedFileName = fileName;
                if (contentDisposition) {
                  const fileNameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
                  if (fileNameStarMatch) {
                    resolvedFileName = decodeURIComponent(fileNameStarMatch[1]);
                  } else {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch) {
                      resolvedFileName = fileNameMatch[1];
                    }
                  }
                }

                const blobUrl = URL.createObjectURL(blob);
                const size = blob.size;
                const units = ["Bytes", "KB", "MB", "GB", "TB"];
                const exponent =
                  size === 0 ? 0 : Math.floor(Math.log10(size) / 3);
                const value = (size / Math.pow(1000, exponent)).toFixed(1);
                const fileSize =
                  size === 0 ? "0 Bytes" : `${value} ${units[exponent]}`;

                this.fileItems[valueId] = {
                  blobUrl,
                  fileName: resolvedFileName,
                  fileSize,
                };
                console.log("this.fileItems1: ", this.fileItems);
              } else {
                this.fileItems[valueId] = {
                  blobUrl: "",
                  fileName: "",
                  fileSize: "",
                };
                console.warn("⚠️ ファイルレスポンスなし:", fileName);
              }
            }
          } else {
            fileName = "";
            valueId = null;
          }
        }
      } catch (error) {
        console.error("❌ downloadFile 全体エラー:", error.message);
      }
    },

    async deleteFile(valueId, deleteTargetName) {
      if (!confirm("本当に削除しますか？この操作は元に戻せません。")) {
        return;
      }
      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");
      const result = await cardSidebarApi.deleteFile(
        authUserId,
        sessionKey,
        valueId,
        deleteTargetName,
        staffName
      );
      if (result) {
        this.fileItems[valueId].fileName = "";
        this.fileItems[valueId].fileSize = "";
        this.fileItems[valueId].blobUrl = "";
        await this.fetchCardData(this.cardId);
        alert("正常に削除されました。");
        eventBus.emit("refreshBoardView");
      }
    },

    // 社員IDが変更されたときにカードタイトルを更新
    updateCardTitle(newId) {
      if (this.selectedScreenName === "営業対象者画面") {
        const staffName = this.getSelectedStaffId(newId);
        this.selectedCard.cardTitle =
          staffName === "未選択" ? "社員未選択" : staffName;
      }
    },

    async getAllStaffName() {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const response = await staffApi.getAllStaffName(authUserId, sessionKey);
        if (response && response.staffList) {
          this.allStaff = {
            staffList: response.staffList.map((staff) => {
              const [staffNum, staffName2] = staff.staffName.split(":");
              return {
                ...staff,
                staffNum,
                staffName2,
              };
            }),
          };
          this.$emit("updateAllStaff", this.allStaff);
        } else {
          this.allStaff = { staffList: [] };
        }
      } catch (error) {
        this.allStaff = { staffList: [] };
      }
    },
    // 社員IDをもとに情報を取得
    async getStaffInfo(staffId, cardId) {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");

        const staffInfo = await staffApi.getStaffInfo(
          staffId,
          cardId,
          authUserId,
          sessionKey
        ); // API呼び出し
        this.selectedStaffInfo = {
          社員名カナ: staffInfo["社員名カナ"] || "",
          年齢: staffInfo["年齢"] || "",
          所属: staffInfo["所属"] || "",
          最寄り駅: staffInfo["最寄り駅"] || "",
          国籍: staffInfo["国籍"] || "",
          パスワード: staffInfo["パスワード"] || "",
        }; // 結果を保存
        this.staffIdFromInfo = staffInfo.staffId;
      } catch (error) {
        console.error("社員情報の取得に失敗:", error.message);
      }
    },
    skillSheet() {
      this.$router.push({
        path: "/skillsheet",
        query: { staffId: this.staffIdFromInfo, cardId: this.cardId },
      });
    },
    //選択された社員を表示する
    getSelectedStaffId(staffId) {
      // allStaff.staffList が非同期データの場合の処理
      if (
        !this.allStaff ||
        !this.allStaff.staffList ||
        this.allStaff.staffList.length === 0
      ) {
        console.error("staffList が未取得または空です");
        return "未選択";
      }

      try {
        // データが取得済みの場合に処理を実行
        const resolvedAllStaff = this.allStaff.staffList;

        // 該当する staffId を検索
        const staff = resolvedAllStaff.find((s) => s.staffId === staffId);

        if (!staff) {
          console.warn("該当するスタッフが見つかりません");
          return "未選択";
        }
        const staffName = staff.staffName;
        this.onlyStaffName = staff.staffName2;
        return staffName;
      } catch (error) {
        console.error("スタッフ名取得中にエラー発生:", error.message);
        return "未選択";
      }
    },

    async updateSelectedCard(card) {
      if (card) {
        this.selectedCard = { ...card };
        await this.fetchCardData(this.selectedCard.cardId);
      } else {
        this.resetSelectedCard();
      }
    },
    createPassword() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let password = "";
      for (let i = 0; i < 10; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.selectedStaffInfo["パスワード"] = password;
      this.savePassword();
    },
    copyPassword() {
      const selectedStaffName = this.selectedStaffName || "未設定";
      const staffNum = (this.selectedStaffNum || "未設定").split(':')[0];
      const password = this.selectedStaffInfo["パスワード"] || "未設定";

      this.copyText = `${selectedStaffName}さん\nお疲れ様です。\n\nスキルシートの更新をお願いします。\nurl: http://dev.nurinubi.com:20081/guestSkillsheet/${staffNum}\npassword: ${password}\n\nよろしくお願いします。`; // ローカル環境:localhost:8081, サーバー：dev.nurinubi.com:20081
      console.log("dd", staffNum)
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(this.copyText)
          .then(() => alert("クリップボードにコピーされました！"))
          .catch((err) => {
            console.error("コピーに失敗しました:", err);
            alert("コピーに失敗しました。手動でコピーしてください。");
          });
      } else {
        // clipboardが使えないhttp://のため
        const textArea = document.createElement("textarea");
        textArea.value = this.copyText;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          alert("クリップボードにコピーされました！");
        } catch (err) {
          console.error("コピーに失敗しました:", err);
          alert("コピーに失敗しました。手動でコピーしてください。");
        }
        document.body.removeChild(textArea);
      }
    },
    resetSelectedCard() {
      this.selectedCard = {
        cardId: null,
        cardTitle: "",
        selectionData: "",
        values: [],
      };
    },
    formatDateTime(targetDate) {
      const date = new Date(targetDate);

      if (!isNaN(date.getTime())) {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(
          2,
          "0"
        );
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hour = String(date.getUTCHours()).padStart(2, "0");
        const minute = String(date.getUTCMinutes()).padStart(
          2,
          "0"
        );
        const second = String(date.getUTCSeconds()).padStart(
          2,
          "0"
        );

        return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
      } else {
        return null;
      }

        
    },
    async fetchCardData(cardId) {
      try {
        const resolvedAllStaff = this.allStaff.staffList;
        if (this.selectedScreenName === "営業対象者画面") {
          if (resolvedAllStaff || resolvedAllStaff.length != 0) {
            const staff = resolvedAllStaff.find(
              (s) =>
                s.staffName.replace(": ", ":") ===
                this.selectedCard.cardTitle.replace(": ", ":")
            );
            if (staff) {
              this.selectedStaffId = staff.staffId;
              this.selectedStaffNum = staff.staffName;
              this.selectedStaffName = staff.staffName2;
              this.copyText = "社員にスキルシートアドレスを送る";
            } else {
              console.log("社員Idが存在しません", staff);
            }
          } else {
            console.log("社員情報が存在しません", resolvedAllStaff);
          }
        }
        if (cardId) {
          this.cardId = cardId;
          // ローカルストレージからデータを取得
          const authUserId = localStorage.getItem("authUserId");
          const sessionKey = localStorage.getItem("sessionKey");

          const cardData = await cardSidebarApi.getCard(
            // カードサイドバー情報取得
            cardId,
            authUserId,
            sessionKey
          );
          this.selectedCard.cardTitle = cardData[0].cardTitle;
          
          if (cardData) {
            this.fileItems = []; // ✅ 初期化
            this.userInputText = {}; // ✅ 初期化
            this.userInputTextBox = []; // ✅ 初期化
            this.userInputText = {}; // ✅ 初期化
            const groupedTextData = {}; // ✅ propertyType === "8" のデータをグループ化

            const hasFileToDownload = cardData.some(
              (item) => item.propertyType === "6" && item.dataValue
            );
            if (hasFileToDownload) {
              await this.downloadFile();
            }

            this.newSelectedCard = cardData
              .map((item) => {
                if (item.propertyType === "8") {
                  if (!groupedTextData[item.propertyId]) {
                    groupedTextData[item.propertyId] = [];
                  }
                  if (item.dataValue) {
                    // ✅ valueId を保持したままオブジェクトとして保存
                    groupedTextData[item.propertyId].push({
                      valueId: item.valueId,
                      dataValue: item.dataValue,
                      updatedDate: item.updatedDate,
                      createdDate: item.createdDate,
                      createdUser: item.createdUser,
                      cardTitle: item.cardTitle,
                    });
                  }

                  // ✅ 最低1つは `newSelectedCard` に含めるため、新しいオブジェクトを作成
                  if (!groupedTextData[item.propertyId].hasPlaceholder) {
                    groupedTextData[item.propertyId].hasPlaceholder = true; // ✅ 重複防止
                    return {
                      propertyId: item.propertyId,
                      propertyName: item.propertyName,
                      propertyType: item.propertyType,
                      dataValue: "", // ✅ 空の値として設定
                      createdDate: item.createdDate,
                      updatedDate: item.updatedDate,
                      selectionData: item.selectionData
                        ? item.selectionData.split(",")
                        : [],
                      valueId: item.valueId,
                      cardTitle: item.cardTitle,
                      valueIds: item.valueIds || [],
                    };
                  }
                  return null; // ✅ 残りは `newSelectedCard` に追加しない
                }

                return {
                  propertyId: item.propertyId,
                  propertyName: item.propertyName,
                  propertyType: item.propertyType,
                  dataValue: item.dataValue,
                  updatedDate: item.updatedDate,
                  createdDate: item.createdDate,
                  selectionData: item.selectionData
                    ? item.selectionData.split(",")
                    : [],
                  valueId: item.valueId,
                  cardTitle: item.cardTitle,
                  valueIds: item.valueIds || [],
                };
              })
              .filter(Boolean); // ✅ `null` を削除して `newSelectedCard` を整

            this.$nextTick(() => {
               this.autoResize();
             });

            // ✅ グループ化されたデータを `userInputTextBox` に保存（1つずつ追加）
            Object.keys(groupedTextData).forEach((propertyId) => {
              groupedTextData[propertyId].forEach(
                ({ valueId, dataValue, updatedDate, createdDate, createdUser }) => {
                  {
                    const updateTime = this.formatDateTime(updatedDate)
                    const createTime = this.formatDateTime(createdDate)
                    this.userInputTextBox.push({
                      valueId,
                      cardId,
                      propertyId: Number(propertyId),
                      propertyType: "8",
                      dataValue,
                      updatedDate: updateTime,
                      createdDate: createTime,
                      createdUser: createdUser || "不明",
                    });
                  }
                }
              );
            });

            this.originalUserInputTextBox = this.userInputTextBox.map(
              (item) => ({ ...item })
            );
          } else {
            console.log("cardData.dataがNULLです");
          }
        } else {
          console.log("cardIdが存在しません", cardId);
        }
      } catch (error) {
        console.error("カードデータの取得に失敗:", error.message);
      }
    },
    formatSelectionData(selectionData) {
      return selectionData.map((item) => {
        const [selectionId, selectionData] = item.split(":");
        return { selectionId, selectionData };
      });
    },
    closeSidebar() {
      this.$emit("update:isVisible", false);
      this.userInputText = {};
    },
    handleFocus(propertyId) {
      this.focusedPropertyId = propertyId;
      this.overlayVisible = true;
    },
    handleBlur() {
      this.focusedPropertyId = null;
      this.overlayVisible = false;
    },
    focusOut(event) {
      event.target.blur();
    },
    handleClickOutside(event) {
      const sidebarEl = this.$refs.sidebarRef;
      const overlayEl = this.$refs.overlayRef;

      const isInsideSidebar = sidebarEl && sidebarEl.contains(event.target);
      const isInsideOverlay = overlayEl && overlayEl.contains(event.target);
      const isDropdown = event.target.closest(".v-menu__content");
      const isTooltip = event.target.closest(".v-tooltip__content");
      const isDialog = event.target.closest(".v-dialog__content");
      const isVuetifyOverlay = event.target.closest(".v-overlay");
      const activeElement = document.activeElement;
      const isFocusInsideSidebar = sidebarEl && sidebarEl.contains(activeElement);
      const isFocusInsideComponent = this.$el && this.$el.contains(activeElement);

      if (
        !isInsideSidebar &&
        !isInsideOverlay &&
        !isFocusInsideSidebar &&
        !isFocusInsideComponent &&
        !isTooltip &&
        !isDialog &&
        !isDropdown &&
        !isVuetifyOverlay &&
        !this.overlayVisible
      ) {
        this.closeSidebar();
      }
    },
    async saveChanges() {
      try {
        this.userInputTextBox.forEach((currentItem, index) => {
          if (currentItem.propertyType === "8" && !currentItem.dataValue) {
            alert("修正するコメントに値を入力してください。")  
            return;
            }
          const originalItem = this.originalUserInputTextBox.find(
            (orig) => orig.valueId === currentItem.valueId
          );
          if (originalItem.dataValue !== currentItem.dataValue) {
            this.updateUserInputText(
              index,
              currentItem.dataValue,
              currentItem.createdUser
            );
          }
        });

        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        const newDataValues = this.newSelectedCard
          .filter((item) => item.propertyType !== "8") // プロパティタイプ=8以外
          .map((item) => ({
            propertyType: item.propertyType,
            dataValue: item.dataValue,
            valueId: item.valueId,
          }));
        await this.updateValue(authUserId, sessionKey, newDataValues);

        await cardSidebarApi.updateCard(
          this.selectedCard.cardId,
          this.selectedCard.cardTitle,
          authUserId,
          sessionKey,
          staffName
        );
        // 変更を即座に反映させるため、UIを更新
        this.updateSelectedCard(this.selectedCard);
        if (this.selectedScreenName === "営業対象者画面") {
          this.savePassword();
        }

        this.properties
          .filter((p) => p.property?.propertyType === "8")
          .forEach((item) => {
            if (this.userInputText !== null && this.userInputText !== "") {
              this.addUserInputText(
                this.cardId,
                item.property.propertyId,
                item.property.propertyType
              );
            }
          });
        console.log("変更が保存されました");
        // 成功メッセージを表示するなど、ユーザーにフィードバックを提供する
        await this.$emit("update-task", this.selectedCard);
        this.closeSidebar();
      } catch (error) {
        console.error("カードの更新に失敗:", error.message);
      }
    },
    async savePassword() {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffId = this.staffIdFromInfo || "";
        const password = this.selectedStaffInfo["パスワード"] || "";

        await savePasswordApi.savePassword(
          authUserId,
          sessionKey,
          staffId,
          password
        );
        console.log("認証情報が保存されました");
      } catch (error) {
        console.error("認証情報の保存に失敗:", error.message);
      }
    },
    openNewValueDialog(valueId, cardId, propertyId,formattedSelectionItems
    ) {
      try {
        if (valueId && cardId && propertyId) {
          this.valueId = valueId;
          this.cardId = cardId;
          this.propertyId = propertyId;
          this.currentFormattedItems = formattedSelectionItems || [];
          this.addValueDialog = true;
        } else {
          console.error(
            "valueId又はpropertyId又はcardIdが存在しません",
            "valueId: ",
            valueId,
            "cardId: ",
            cardId,
            "propertyId:",
            propertyId
          );
        }
      } catch (error) {
        console.log("値追加失敗", error.message);
      }
    },

    async saveNewValue() {
      try {
        const invalidCharRegex = /\\\\|[,:]/;
        if (invalidCharRegex.test(this.newValueTitle)) {
          alert("「\\\\」「,」「:」は使用できません。");
          return;
        }
        const isDuplicate = this.currentFormattedItems.some(
            item => item.selectionData === this.newValueTitle
          );

          if (isDuplicate) {
            alert("同じ名前のプロパティが既に存在します。");
            return;
          }
        if (this.propertyId != null && this.newValueTitle) {
          const authUserId = localStorage.getItem("authUserId");
          const sessionKey = localStorage.getItem("sessionKey");
          const staffName = localStorage.getItem("staffName");
          const result = await cardSidebarApi.addValue(
            this.propertyId,
            this.newValueTitle,
            authUserId,
            sessionKey,
            staffName
          );
          console.log("値追加成功：", result);
          await this.fetchCardData(this.cardId);
          this.addValueDialog = false;
          this.newValueTitle = null;
        } else {
          console.error("valueIdが存在しません", this.valueId);
        }
      } catch (error) {
        console.log("失敗");
        console.error(error.message);
      }
    },
    async updateValue(authUserId, sessionKey, newDataValues) {
      try {
        if (this.userInputText) {
          const key = Object.keys(this.userInputText)[0];
          const inputText = this.userInputText[key] || "";
          newDataValues.push({
            propertyType: "8",
            dataValue: inputText,
            valueId: null,
          });
        }
        const files = newDataValues
          .filter(
            (item) =>
              item.propertyType === "6" && item.dataValue instanceof File
          )
          .map((item) => item.dataValue);

        const encodedDataValues = newDataValues.map(item => {
          if (item.propertyType === "6") {
            return item;
          }
          return {
            ...item,
            dataValue: this.encode(item.dataValue)
          };
        });
        await cardSidebarApi.updateValue(
          authUserId,
          sessionKey,
          encodedDataValues,
          files,
          {}
        );
      } catch (error) {
        console.log("失敗");
        console.error(error.message);
      }
    },
    async updateComment(authUserId, sessionKey, newDataValues) {
      try {
        // 新規作成したコメントのみ残す
        const newComment = this.userInputTextBox.find(
          (item) => item.valueId === null
        );

        // 既存のコメントで更新されたコメントのみ残す
        const updatedComments = this.userInputTextBox.filter((currentItem) => {
          if (currentItem.valueId === null) return false;

          const originalItem = this.originalUserInputTextBox.find(
            (orig) => orig.valueId === currentItem.valueId
          );

          return (
            originalItem && originalItem.dataValue !== currentItem.dataValue
          );
        });

        // 最終更新の配列
        const targetComments = [
          ...(newComment ? [newComment] : []),
          ...updatedComments,
        ];
        const encodedDataValues = targetComments.map(item => {
          return {
              ...item,
              dataValue: this.encode(item.dataValue)
            };
        });

        const result = await cardSidebarApi.updateValue(
          authUserId,
          sessionKey,
          newDataValues,
          {},
          encodedDataValues
        );
        if (result) {
          if (newComment && result.data?.results[0]?.[0]?.value_id) {
            newComment.valueId = result.data.results[0][0].value_id;
          }
          this.originalUserInputTextBox = this.userInputTextBox.map(
            (item) => ({ ...item })
          );
          this.userInputText = {};
        }
      } catch (error) {
        // alert("コメントの追加または更新に失敗しました");
        console.log("失敗");
        console.error(error.message);
      }
    },
    async deleteValue(valueId, dataValue, selectionData) {
      try {
        if (dataValue === null || undefined) {
          console.log(
            "削除する値を選択してください。\n",
            "valueId: ",
            valueId,
            "dataValue: ",
            dataValue
          );
          alert("削除する値を選択してください。");
        } else {
          if (!selectionData || selectionData.length <= 1) {
            alert("セレクトが1個以下の時は削除できません。\n最低1つのセレクトは保持する必要があります。");
            return;
            }
          if (!confirm("本当に削除しますか？この操作は元に戻せません。")) {
            return;
          }
          const authUserId = localStorage.getItem("authUserId");
          const sessionKey = localStorage.getItem("sessionKey");
          const staffName = localStorage.getItem("staffName");
          await cardApi.deleteData(
            valueId,
            "",
            "",
            dataValue,
            authUserId,
            sessionKey,
            staffName
          );
          await this.fetchCardData(this.cardId);
          await eventBus.emit("refreshBoardView");
        }
      } catch (error) {
        console.log("失敗");
        console.error(error.message);
      }
    },

    formatSelectionItems(selectionItems) {
      return selectionItems.map((item) => item.dataValue || "なし").join(", ");
    },

    // 数量フィールドの入力処理（整数 + 10文字制限）
  handleQuantityInput(event, cardValue) {
    const floorValue = Math.floor(event.target.value);
    const valueStr = floorValue.toString();
    cardValue.dataValue = valueStr.length > 10 ? parseInt(valueStr.slice(0, 10)) : floorValue;
  },
  
  // 少数フィールドの入力処理（小数 + 10文字制限）
  handleDecimalInput(event, cardValue) {
    const value = event.target.value.toString();
    if (value.length > 10) {
      cardValue.dataValue = parseFloat(value.slice(0, 10));
    }
  },

  },
};
</script>

<style scoped>
.custom-disabled-textarea textarea {
  color: black !important;
  -webkit-text-fill-color: black !important;
  opacity: 1 !important;
  background-color: #f5f5f5 !important;
}

.execel-file-input {
  margin-top: 20px;
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: all 0.3s ease;
}
.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.sidebar-slide-enter-to,
.sidebar-slide-leave-from {
  opacity: 1;
  transform: translateX(0%);
}

.left-align {
  text-align: left;
  /* 左寄せ */
  display: inline-block;
  /* 要素がインラインで表示されるようにする */
}

.prop-select {
  width: 30px;
  /* 幅を60%に設定 */
}

.property-item {
  margin-bottom: 15px;
}

.focused {
  position: relative;
  z-index: 3000;
}

.property-actions {
  margin-top: 10px;
}

.card-side-bar {
  position: fixed;
  /* 固定位置に設定 */
  top: 0;
  /* 上部に配置 */
  right: 0;
  /* 右側に配置 */
  width: 33.33vw;
  /* 幅を画面の1/3に設定 */
  height: 100vh;
  /* 高さを画面全体に設定 */
  background-color: #f9f9f9;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  /* 必要に応じてスクロール可能に */
  z-index: 1000;
  /* 最前面に表示するために z-index を設定 */
}

.close-button {
  color: blue;
  border: none;
  cursor: pointer;
  font-size: 32px;
  position: absolute;
  background: none;
  top: 18px;
  width: auto;
  height: auto;
  box-shadow: none;
}

.close-button:hover {
  background-color: #e0e0e0;
  /* やや暗めの背景 */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* 立体感を追加 */
  transition: background-color 0.2s, box-shadow 0.2s;
}

.close-button:focus {
  outline: none;
  box-shadow: none;
}

.task-title {
  font-size: 18px;
  font-weight: bold;
  margin: 20px;
  /* さらに右に移動 */
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.label {
  text-align: right;
  margin-right: 10px;
}

input {
  flex-grow: 1;
  padding: 8px;
  font-size: 14px;
}

.save-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  width: 100%;
  z-index: 3000;
}

.add-button {
  background-color: blue;
  color: white;
  margin-left: auto;
  margin-right: 20px;
  position: absolute;
  margin-top: 20px;
  right: 0px;
  /* 右端に配置 */
}

.delete-button {
  background-color: white;
  color: blue;
  margin-left: auto;
  margin-right: 20px;
  margin-top: 20px;
  /* 必要に応じて右マージンを調整 */
  border: 1px solid blue;
  right: 70px;
}

.user-input-box-container {
  width: 100%;
}

.user-input-box {
  background-color: #f9fafb;
  border: 1px solid #e0e0e0;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin: 2px;
  font-size: 12px;
  color: #4a4a4a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s, box-shadow 0.2s;
}

/* アイコンのホバー効果 */
.action-icon {
  font-size: 24px;
  /* アイコンのサイズ */
  cursor: pointer;
  /* クリック可能にする */
  padding: 8px;
  /* クリック可能な領域を拡張 */
  border-radius: 6px;
  /* 角を丸くする */
  transition: background-color 0.2s ease-in-out;
}

.action-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
  /* マウスオーバー時に背景色を変更 */
}

.custom-file-input:hover {
  background-color: rgba(58, 14, 255, 0.05);
  /* 淡い灰色の背景 */
  transition: background-color 0.2s ease-in-out;
}

/* prepend-iconのホバー効果 */
:deep(.v-input__control .v-icon) {
  transition: color 0.2s ease-in-out;
}

/* ✅ v-file-inputをsolo-filledのスタイルにする */
.custom-file-input {
  background-color: #f5f5f5;
  /* デフォルトの背景 */
  border-radius: 8px;
  /* 角を丸くする */
  padding: 10px 12px;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

/* ✅ ホバー効果を追加 */
.custom-file-input:hover {
  background-color: #e0e0e0;
  /* やや暗めの背景 */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* 立体感を追加 */
}

/* ✅ リストのスタイル */
.custom-list {
  background: transparent;
}

/* ✅ リストアイテムをsolo-filledのスタイルに変更 */
.custom-list-item {
  background-color: #ffffff;
  /* 背景色 */
  border: 1px #4a4a4a;
  /* ボーダー */
  border-radius: 8px;
  /* 角を丸くする */
  padding: 12px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
}

/* ✅ ファイルダウンロードリンクのスタイル */
.file-link-container {
  display: flex;
  margin-left: 15px;
  width: 100%;
  min-width: 0;
}

.file-link {
  text-decoration: none;
  color: blue;
  cursor: pointer;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.file-link:hover {
  text-decoration: underline;
}

/* 🔵 */
.active-icon {
  color: #1e88e5 !important;
}

/* ⚫ */
.disabled-icon {
  color: #bdbdbd !important;
  pointer-events: none;
}

.custom-input {
  width: 100%;
  max-width: 70vh;
  height: 45px;
  font-size: 25px;
  font-weight: bold;
  padding: 8px 12px;
  border-radius: 6px;
  transition: border-color 0.2s ease-in-out;
  resize: none;
  overflow: hidden;
  line-height: 1.4;
}

.custom-input:hover {
  border-color: #868686;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  background-color: rgba(63, 63, 63, 0.05);
}

.custom-input:focus {
  border-color: #1e88e5;

  box-shadow: 0px 4px 6px rgba(13, 118, 255, 0.1);
}

.avatar-text {
  color: white;
  font-size: 15px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 4px;
  text-align: center;
}

.dynamic-avatar {
  flex: 0 1 50px;
  max-width: 50px;
  max-height: 50px;
  min-width: 30px;
  min-height: 30px;
}

.small-btn {
  min-width: none;
}

.transparent-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0);
  z-index: 2000;
}

/* 固定表示 */
.no-shrink {
  flex-shrink: 0;
}
</style>
